<template>
  <div class="StockConfig-page" ref="container">
		<div class="info-content">
			<div class="info-box">
				<div class="info-box-content">
					<div class="info-box-label" @click="edit('bodywash')">
						<div class="label-name">沐浴露（ml）</div>
						<div class="label-value">{{info.bodywash}}</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
					<div class="info-box-label" @click="edit('conditioner')">
						<div class="label-name">护发素（ml）</div>
						<div class="label-value">{{info.conditioner}}</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
					<div class="info-box-label" @click="edit('disinfectant')">
						<div class="label-name">消毒剂（ml）</div>
						<div class="label-value">{{info.disinfectant}}</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
				</div>
			</div>
		</div>
	
		<Popup v-model="showPopup" closeable round>
			<div class="view-wrap">
				<div class="stock">
					<div class="value">{{info[type]||''}}ml</div>
					<div class="btn-row">
						<div class="btn plus" @click="add(100)"> +100ml </div>
						<div class="btn plus" @click="add(1000)"> +1000ml </div>
					</div>
					<div class="btn-row">
						<div class="btn minus" @click="minus(100)"> -100ml </div>
						<div class="btn minus" @click="minus(1000)"> -1000ml </div>
					</div>
				</div>
			</div>
		</Popup>
		
	</div>
</template>
<script>
import PetApi from "../../api/petAdmin";
import {Popup} from 'vant';
export default {
  name: "PetAdminStockConfig",
  components: {
		Popup
	},
  props: {},
  data: function() {
    return {
			info : {},
			type : '',
			showPopup : false,
			deviceSn: this.$route.params.deviceSn,
    };
  },
  watch: {
    "$route.params.deviceSn": function(newVal) {
      var that = this;
      if (newVal != undefined && newVal != that.deviceSn) {
    		that.deviceSn = newVal;
    		that.getInfo()
      }
    }
  },
  mounted: function() {
		this.getInfo()
  },
  computed: {},
  methods: {
		edit(type) {
			this.type = type;
			this.showPopup = true;
		},
		add(num) {
			this.submit(this.type, num, 'add');
		},
		minus(num) {
			this.submit(this.type, num, 'minus');
		},
		submit(type, num, method) {
			let that = this;
			PetApi.petDeviceStockConfig({
				deviceSn: that.deviceSn,
				type: that.type,
				num: num,
				method: method,
			}).then(
			  res => {
					that.info[that.type] = res.data.value;
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		},
		getInfo() {
			let that = this;
			PetApi.petDeviceConfigInfo(that.deviceSn).then(
			  res => {
					that.info = res.data;
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		}
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.StockConfig-page {
	
	.info-content {
		padding: 0 0.32rem;
		.info-box {
			background: #FFFFFF;
			border-radius: .20rem;
			margin-top: 0.48rem;
			position: relative;
	
			.info-box-content {
				padding: 0 0.3rem;
				
				.info-box-label {
					display: flex;
					justify-content: space-between;
					height: 1rem;
					align-items: center;
					
					&:not(:last-child) {
						border-bottom: 0.02rem solid #E8E8E8;
					}
					
					
					.label-name {
						font-weight: 400;
						font-size: .28rem;
						color: #000000;
						width: 2.7rem;
					}
					.label-value {
						font-weight: 400;
						font-size: .28rem;
						color: #999999;
						text-align: right;
						flex: 1;
					}
					
					.iconfont {
						font-weight: 600;
						font-size: 0.28rem;
						margin-left: 0.12rem;
						color: #888888;;
					}
				}
			}
		}
	}

	.view-wrap {
		width: 5.8rem;
		height: 4.7rem;
		margin-top: 1.6rem;
	}
		
	.stock {
		.value {
			text-align: center;
			font-weight: bolder;
			font-size: 0.48rem;
			margin-bottom: 0.8rem;
		}
		.btn-row {
			display: flex;
			justify-content: space-evenly;
			margin-bottom : 0.3rem;
		}
		.btn {
			text-align: center;
			width: 2rem;
			height: 0.6rem;
			border-radius: 0.1rem;
			color: #fff;
			padding: 0.1rem 0.2rem;
			box-sizing: border-box;
			
			
			&.plus {
				background-color: #67C23A;
			}
			&.minus {
				background-color: #F56C6C;
			}
		}
	}

}

</style>
